import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { of, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { AuthStateService } from './auth-state.service';
import { SessionInactivityService } from './session-inactivity.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
    const snackBar = inject(MatSnackBar);
    const router = inject(Router);
    const authStateService = inject(AuthStateService);
    const inactivityService = inject(SessionInactivityService);

    return next(req).pipe(
        tap((response) => {
            // On successful response, reset inactivity timer.
            if (isRecipientApiRequest(req.url)) {
                inactivityService.resetActivity();
            }
        }),
        catchError((error: unknown) => {
            if (isRecipientApiRequest(req.url) && error instanceof HttpErrorResponse && error.status === 401) {
                // If it's the initial auth check request, let the auth service handle it.
                if (req.url.includes('/check')) {
                    return throwError(() => error);
                }

                // Only show a session expiration message if the user is on a protected route.
                if (authStateService.isOnProtectedRoute()) {
                    const snackBarRef = snackBar.open(
                        'Session expired. Logging you out...',
                        'Dismiss',
                        { duration: 3000 }
                    );

                    snackBarRef.afterDismissed().subscribe(() => {
                        router.navigate(['/login']);
                    });

                    return of();
                }

                return throwError(() => error);
            }

            return throwError(() => error);
        })
    );
};

function isRecipientApiRequest(url: string): boolean {
    return url.startsWith(environment.apiBaseUrl);
}
